// AiBannedView — pausad-vyn när user är moderation-bannad i AI-
// assistenten. Extraherad ur AiAssistantDialog (#1 i
// PRE_RELEASE_REVIEW_100). Appeal-flödet ägs av dialogen (öppnar
// AppealDialog via onAppeal).

import { Gavel } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function AiBannedView({ minHeight, onAppeal }: {
  minHeight: string;
  onAppeal: () => void;
}) {
  return (
    <div className="flex flex-col h-full items-center justify-center p-8" style={{ minHeight }}>
      <div className="text-center space-y-4 max-w-sm">
        <div className="w-16 h-16 rounded-full bg-amber-500/10 flex items-center justify-center mx-auto">
          <span className="text-3xl">⏸️</span>
        </div>
        <h3 className="text-lg font-bold text-amber-700 dark:text-amber-500">AI-assistenten är pausad</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Tillgången är tillfälligt blockerad pga upprepade scope-flaggningar.
          Klassificeraren kan ha felbedömt en legitim workflow-fråga — i så
          fall kan du överklaga.
        </p>
        <Button
          onClick={onAppeal}
          className="gap-1.5"
          data-testid="banned-view-appeal-button"
        >
          <Gavel className="w-4 h-4" />
          Överklaga banet
        </Button>
        <p className="text-xs text-muted-foreground/60 pt-2 border-t">
          Sysadmin kan rensa false-positives via AI Ops-panelen
          (admin_clear_moderation_event[s]_for_correlation).
        </p>
      </div>
    </div>
  );
}
